// Low-stock detection.
//
// A number field marked `config.role === "stock_qty"` holds the on-hand
// quantity; one marked `config.role === "stock_min"` holds the reorder
// threshold. A record is "low stock" when qty ≤ min (both present & numeric).
// Templates set these roles (furnishing store, inventory-lite); nothing is
// hard-coded to a specific field key.

export function stockKeys(fieldDefs = []) {
  const qty = fieldDefs.find((f) => f?.config?.role === "stock_qty");
  const min = fieldDefs.find((f) => f?.config?.role === "stock_min");
  return qty && min ? { qtyKey: qty.key, minKey: min.key } : null;
}

export function isLowStock(values = {}, keys) {
  if (!keys) return false;
  const q = Number(values[keys.qtyKey]);
  const m = Number(values[keys.minKey]);
  if (Number.isNaN(q) || Number.isNaN(m)) return false;
  return q <= m;
}
